import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../../components/LoginForm';
import { useAuth } from '../../context/AuthContext';
import { adminLogin } from '../../services/api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (email, password) => {
    const data = await adminLogin(email, password);
    login(data, email, { isSuperAdmin: true });
    navigate('/admin');
  };

  return (
    <LoginForm
      title="Sign in as OW Super Admin"
      subtitle="Restricted area. Super admin accounts only."
      onSubmit={handleLogin}
    />
  );
};

export default AdminLogin;
